import type {
  EvictionSnapshot,
  StreamPlan,
  StreamSubscriptionStatus,
} from "./billing";

export enum StreamingPlatformEnum {
  youtube = "youtube",
  twitch = "twitch",
  kick = "kick",
  custom = "custom",
}
export enum StreamVersionEnum {
  regular = "regular",
  beta = "beta",
}

export enum GenderEnum {
  male = "male",
  female = "female",
}

export enum VisualMediaTypeEnum {
  video = "video",
  image = "image",
  gif = "gif",
}
export enum VisualMediaClassificationEnum {
  playlistVideo = "playlistVideo",
  background = "background",
  overlay = "overlay",
}

export enum EncodeStatusEnum {
  none = "none",
  queued = "queued",
  running = "running",
  succeeded = "succeeded",
  failed = "failed",
  cancelled = "cancelled",
}

export enum LiveStreamTypeEnum {
  playlist = "playlist",
  video = "video",
  forwarding = "forwarding",
}

export enum LiveStreamStatus {
  restarting = "restarting",
  initilizing = "initilizing",
  scheduled = "scheduled",
  starting = "starting",
  preparingMedia = "preparingMedia",
  finalizing = "finalizing",
  compiling = "compiling",
  live = "live",
  pausing = "pausing",
  paused = "paused",
  resuming = "resuming",
  ending = "ending",
  ended = "ended",
  stopping = "stopping",
  stopped = "stopped",
  start_missed = "start_missed",
  failed_provision = "failed_provision",
  partial_failed = "partial_failed",
  archived = "archived",
}

export enum LiveStreamPlaybackOrderEnum {
  random = "random",
  sequential = "sequential",
}

export enum LiveStreamOrientationEnum {
  horizontal = "horizontal",
  vertical = "vertical",
}

export enum LiveStreamResolutionEnum {
  r1080p = "r1080p",
  r2160p = "r2160p",
}

export enum OverlayTypeEnum {
  text = "text",
  song_title = "song_title",
  song_author = "song_author",
  song_title_metadata = "song_title_metadata",
  song_author_metadata = "song_author_metadata",
  song_album_metadata = "song_album_metadata",
  image = "image",
  video = "video",
  gif = "gif",
  rectangle = "rectangle",
  circle = "circle",
  custom_rectangle = "custom_rectangle",
  complex_text = "complex_text",
  arrow = "arrow",
  ellipse = "ellipse",
  ring = "ring",
  countdown = "countdown",
  digital_clock = "digital_clock",
  web_source = "web_source",
  progress = "progress",
  donors_chatters_list = "donors_chatters_list",
  marquee_text = "marquee_text",
  analog_clock = "analog_clock",
  triangle = "triangle",
  audio_visualizer = "audio_visualizer",
}

export enum OverlayTextAlignEnum {
  left = "left",
  center = "center",
  right = "right",
}

export enum OverlayCountdownStyleEnum {
  military = "military",
  detailed = "detailed",
}
export enum OverlayClockFormatEnum {
  "24_hour" = "24-hour",
  "12-hour" = "12-hour",
}
export enum OverlayProgressTypeEnum {
  bar = "bar",
  circular = "circular",
}
export enum OverlayProgressPlatformEnum {
  youtube = "youtube",
  twitch = "twitch",
}

export enum OverlayProgressChannelYoutubeSelectedMainTypeEnum {
  channel_subscribers = "channel_subscribers",
}
export enum OverlayProgressChannelTwitchSelectedMainTypeEnum {
  channel_followers = "channel_followers",
}
export enum OverlayProgressSelectedMainTypeEnum {
  live_stream_likes = "live_stream_likes",
  live_stream_live_viewers = "live_stream_live_viewers",
}
export enum OverlayProgressSelectedSubTypeEnum {
  likes = "likes",
  subscribers = "subscribers",
}
export enum OverlayProgressShapeTypeEnum {
  first_shape = "first_shape",
  second_shape = "second_shape",
}
export enum OverlayProgressPatternTypeEnum {
  first_pattern = "first_pattern",
  second_pattern = "second_pattern",
}
export enum OverlayProgressStartTextTypeTypeEnum {
  current = "current",
  static = "static",
}
export enum OverlayVisualizerShapeTypeEnum {
  default = "default",
  circular = "circular",
  bars = "bars",
  simple_mirror_bars = "simple_mirror_bars",
  small_mirror_bars = "small_mirror_bars",
  rotating_spirals = "rotating_spirals",
  rotating_circles = "rotating_circles",
  geometric_polygons = "geometric_polygons",
  waves = "waves",
  sunburst = "sunburst",
  mirror_bars = "mirror_bars",
  mirror_lines = "mirror_lines",
  wavy_line = "wavy_line",
  particles = "particles",
  particle_field = "particle_field",
}

export enum OverlayStrokeTextGradientDirectionTypeEnum {
  RIGHT = "to_right",
  LEFT = "to_left",
  TOP = "to_top",
  BOTTOM = "to_bottom",
  RIGHT_TOP = "to_right_top",
  RIGHT_BOTTOM = "to_right_bottom",
  LEFT_TOP = "to_left_top",
  LEFT_BOTTOM = "to_left_bottom",
  CIRCLE = "circle",
}

export enum OverlayStrokeTextStrokeTypeEnum {
  solid = "solid",
  gradient = "gradient",
}

export enum OverlayStrokeTextFillTypeEnum {
  solid = "solid",
  gradient = "gradient",
}
export enum OverlayVisualizerParticlesCenterShapeTypeEnum {
  none = "none",
  image = "image",
  circle = "circle",
  rectangle = "rectangle",
}

export enum OverlayListTypeEnum {
  donors = "donors",
  chatters = "chatters",
}
export interface OverlayListItemType {
  name: string;
  amount: number;
}

export enum OverlayCountdownFormatEnum {
  days = "days",
  hours = "hours",
  minutes = "minutes",
  seconds = "seconds",
}
export enum OverlayMarqueeHorizontalDirectionEnum {
  left_to_right = "left_to_right",
  right_to_left = "right_to_left",
}
export enum OverlayMarqueeVerticalDirectionEnum {
  up_to_down = "up_to_down",
  down_to_up = "down_to_up",
}
export enum OverlayMarqueeBehaviorEnum {
  vertical = "vertical",
  horizontal = "horizontal",
  bounce = "bounce",
}
export enum OverlayMarqueeTextPositionEnum {
  start = "start",
  center = "center",
  end = "end",
}
export enum OverlayAnalogClockHoursNumbersTypeEnum {
  arabic = "arabic",
  indian = "indian",
  roman = "roman",
}
export enum OverlayAnalogClockShapeEnum {
  circle = "circle",
  square = "square",
}

export enum UserRoleEnum {
  user = "user",
  admin = "admin",
}

export enum UserStatus {
  active = "active",
  suspended = "suspended",
  toBeDeleted = "toBeDeleted",
}

export enum LiveStreamStartOptionEnum {
  now = "now",
  schedule = "schedule",
}

export enum LiveStreamEndOptionEnum {
  never = "never",
  contentEnd = "contentEnd",
  schedule = "schedule",
}

export enum FolderTypeEnum {
  video = "video",
  audio = "audio",
}

export enum VisualMediaImportFromEnum {
  googleDrive = "googleDrive",
}

export enum LiveStreamJingleEveryTypeEnum {
  minutes = "minutes",
  songs = "songs",
}

export interface IIP {
  id: string;
  ip: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}
/** GET /auth/me projects each stream to its id and subscription only. */
export interface IUserStreamSummary {
  id: string;
  subscription: { plan: StreamPlan; status: StreamSubscriptionStatus } | null;
}

export interface CleanupSuggestion {
  liveStreamId: string;
  userId: string;
  reason: string;
  subscriptionStatus: string;
}

export interface IUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  country: string;
  role: "admin" | "user";
  verified: boolean;
  hasOldExperience: boolean;
  trialUsed: boolean;

  lastSeenAt?: string;
  liveStreams?: IUserStreamSummary[];
  cleanupSuggestions?: CleanupSuggestion[];
  visualMediaSum?: number;
  audioSum?: number;
  latestIP?: string;
  registerIP?: string;
  userIPs?: IIP[];
  status?: UserStatus;
  /** B12: when an admin last changed `status`. */
  statusChangedAt?: string | null;
}

export interface IStreamingPlatform {
  id: string;
  name?: string;
  platform: StreamingPlatformEnum;
  streamKey?: string;
  streamUrl?: string;
  channelId?: string;
  liveStreamId: string;
  /** Selected for the stream's output (replaces the old join row). */
  enabled: boolean;
  status?: string | null;
  lastError?: string | null;
  errorCode?: string | null;
  reconnectCount: number;
  isDegraded?: boolean;
  viewers: number;
  likes: number;
  videoKey?: string | null;
  createdAt: Date | string;
  updatedAt: Date | string;
}

export interface IAudio {
  id: string;
  name: string;
  author?: string | null;
  fileName: string;
  url: string;
  optimizedUrl?: string | null;
  optimizedUrlKey?: string | null;
  key: string;
  sizeInKB: number;
  duration: number;
  durationErrorCount: number;
  liveStreamId: string;
  folderId?: string;
  folder?: IFolder;
  createdAt: Date;
  updatedAt: Date;
}

export interface IVideoAudio {
  id: string;
  order: number;
  downloaded: boolean;
  videoId: string;
  audioId: string;
  audio: IAudio;
  createdAt: Date;
  updatedAt: Date;
}
export interface IVisualMedia {
  id: string;
  classification: VisualMediaClassificationEnum;
  type: VisualMediaTypeEnum;
  importLoading: boolean;
  importFrom?: VisualMediaImportFromEnum | null;
  name: string;
  author?: string | null;
  fileName: string;
  url: string;
  thubmnailUrl?: string | null;
  thumbnailError?: string | null;
  thumbnailSecond?: number | null;
  optimizedUrl?: string | null;
  optimizedUrlKey?: string | null;
  key: string;
  sizeInKB: number;
  duration: number;
  width?: number;
  height?: number;
  resolutionTier?: LiveStreamResolutionEnum | null;
  resolutionError?: string | null;
  durationErrorCount: number;
  encodeStatus: EncodeStatusEnum;
  encodeError?: string | null;
  encodedAt?: Date | string | null;
  folderId?: string;
  folder?: IFolder;
  liveStreamId: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IFolder {
  id: string;
  isFolder: true;
  name: string;
  type: FolderTypeEnum;
  liveStreamId: string;
  visualMedias: IVisualMedia[];
  audios: IAudio[];
  createdAt: Date;
  updatedAt: Date;
  _count: { audios: number; visualMedias: number };
}

export interface IOverlaySettings {
  radius?: number;
  radiusX?: number;
  radiusY?: number;
  cornerRadius?: number[];
  points?: number[];
  pointerLength?: number;
  pointerWidth?: number;
  stroke?: string;
  strokeWidth?: number;
  innerRadius?: number;
  outerRadius?: number;
  rotation?: number;
  countdownStyle?: OverlayCountdownStyleEnum;
  countdownFormat?: OverlayCountdownFormatEnum[];
  hideWhenFinished?: boolean;
  countdownDate?: Date;
  clockFormat?: OverlayClockFormatEnum;
  webSourceLink?: string;
  platform?: OverlayProgressPlatformEnum;
  progressSelectedMainType?:
    | OverlayProgressSelectedMainTypeEnum
    | OverlayProgressChannelYoutubeSelectedMainTypeEnum
    | OverlayProgressChannelTwitchSelectedMainTypeEnum;
  progressType?: OverlayProgressTypeEnum;
  progressPattern?: OverlayProgressPatternTypeEnum;
  progressShape?: OverlayProgressShapeTypeEnum;
  pattern?: boolean;
  progressLink?: string;
  progressFill?: string;
  barWidth?: number;
  barHeight?: number;
  startText?: string;
  startTextType?: OverlayProgressStartTextTypeTypeEnum;
  startFontSize?: number;
  startFill?: string;
  startBold?: boolean;
  startItalic?: boolean | null;
  startTextDecoration?: string | null;
  endText?: string;
  endFontSize?: number;
  endFill?: string;
  endBold?: boolean;
  endItalic?: boolean | null;
  endTextDecoration?: string | null;
  secondShapeMiddleText?: string;
  secondShapeMiddleFontSize?: number;
  secondShapeMiddleFill?: string;
  secondShapeMiddleBold?: boolean;
  secondShapeMiddleItalic?: boolean | null;
  secondShapeMiddleTextDecoration?: string | null;
  barRadius?: number;
  progressRadius?: number;
  abbreviatedStartNumber?: boolean;
  abbreviatedEndNumber?: boolean;
  barOpacity?: number;
  progressOpacity?: number;
  gapX?: number;
  gapY?: number;
  circularProgressRadius?: number;
  circularProgressThickness?: number;
  circularProgressTextEnabled?: boolean;
  circularProgressTextFontSize?: number;
  circularProgressTextFill?: string;
  circularProgressTextBold?: boolean;
  circularProgressTextItalic?: boolean | null;
  circularProgressTextDecoration?: string | null;
  maxDonorsItems?: number;
  donorItemTextFontSize?: number;
  donorItemTextFill?: string;
  donorItemTextDecoration?: string | null;
  donorItemTextBold?: boolean | null;
  donorItemTextItalic?: boolean | null;
  listType?: OverlayListTypeEnum;
  donorListShowValue?: boolean;
  donorListAbbreviatedValue?: boolean;
  listItems?: OverlayListItemType[];
  listPaddingX?: number;
  listPaddingY?: number;
  listRadius?: number;
  marqueeTextFontSize?: number;
  marqueeTextFill?: string;
  marqueeTextDecoration?: string | null;
  marqueeTextBold?: boolean | null;
  marqueeTextItalic?: boolean | null;
  marqueeTextBehavior?: OverlayMarqueeBehaviorEnum;
  marqueeTextHorizontalDirection?: OverlayMarqueeHorizontalDirectionEnum;
  marqueeTextVerticalDirection?: OverlayMarqueeVerticalDirectionEnum;
  marqueeTextDuration?: number;
  marqueeText?: string;
  marqueeTextStrokeEnabled?: boolean | null;
  marqueeTextStrokeFill?: string;
  marqueeTextStrokeWidth?: number;
  // marqueeRadius?: number;
  marqueeOpacity?: number;
  marqueeStrokeOpacity?: number;
  marqueeTextPosition?: OverlayMarqueeTextPositionEnum;
  analogClockMinuteMarkersEnabled?: boolean | null;
  analogClockHoursNumbersEnabled?: boolean | null;
  analogClockHoursNumbersType?: OverlayAnalogClockHoursNumbersTypeEnum;
  analogClockHoursNumbersFill?: string;
  analogClockHoursNumbersTextDecoration?: string | null;
  analogClockHoursNumbersBold?: boolean | null;
  analogClockHoursNumbersItalic?: boolean | null;
  analogClockHoursFill?: string;
  analogClockMinutesFill?: string;
  analogClockSecondsFill?: string;
  analogClockCenterCircleFill?: string;
  analogClockMinuteMarkersFill?: string;
  analogClockRadius?: number;
  analogClockCenterCircleRadius?: number;
  analogClockSquareRadius?: number;
  analogClockShape?: OverlayAnalogClockShapeEnum;
  clockTimeZone?: string;
  shadowEnabled?: boolean;
  shadowColor?: string;
  shadowBlur?: number;
  shadowOffsetX?: number;
  shadowOffsetY?: number;
  shadowOpacity?: number;
  url?: string | null;
  visualizerSongURL?: string;
  visualizerSongCurrentTime?: number;
  visualizerShapeType?: OverlayVisualizerShapeTypeEnum;
  visualizerParticlesCenterShapeType?: OverlayVisualizerParticlesCenterShapeTypeEnum;
  visualizerBarsGap?: number;
  visualizerLineWidth?: number;
  particlesCenterShapeRadius?: number;
  particlesCenterShapeSize?: number;
  particlesCircleMinSize?: number;
  particlesCircleRangeSize?: number;
  particlesCenterShapeFill?: string;
  maxParticlesNumber?: number;
  particlesEmissionRateNumber?: number;
  sunburstCenterCircleRadius?: number;
  shapeColor?: string;
  fftSize?: number;
  shapeScale?: number;
  shapeRadius?: number;
  barHeightMultiplier?: number;
  bottomShapeHeight?: number;
  bottomShapeColor?: string;
  waveAmplitude?: number;
  waveFrequency?: number;
  particlesShapeImage?: {
    imageData: IVisualMedia;
    width: number;
    height: number;
  };
  centralizedText?: boolean;
  digitalClockDateEnabled?: boolean;
  digitalClockDateShowDay?: boolean;
  digitalClockDateFontSize?: number;
  digitalClockDateTextColor?: string;
  digitalClockDateTextBold?: boolean;
  digitalClockDateTextDecoration?: string | null;
  digitalClockDateTextItalic?: boolean | null;
  strokeTextStrokeEnabled?: boolean;
  strokeTextStrokeType?: OverlayStrokeTextStrokeTypeEnum;
  strokeTextFillType?: OverlayStrokeTextFillTypeEnum;
  strokeTextFillColorStops?: (string | number)[];
  strokeTextStrokeColorStops?: (string | number)[];
  strokeTextLetterSpacing?: number;
  strokeTextFillGradientDirection?: OverlayStrokeTextGradientDirectionTypeEnum;
  strokeTextStrokeGradientDirection?: OverlayStrokeTextGradientDirectionTypeEnum;
  textFontFamily?: string;
}

export interface IOverlay {
  id: string;
  type: OverlayTypeEnum;
  top?: number | null;
  left?: number | null;
  width?: number | null;
  height?: number | null;
  order: number;
  fontSize?: number | null;
  bold?: boolean | null;
  italic?: boolean | null;
  textDecoration?: string | null;
  fill?: string | null;
  text?: string | null;
  textAlign?: OverlayTextAlignEnum | null;
  videoId?: string | null;
  playlistId?: string | null;
  visualMediaId?: string | null;
  visualMedia?: IVisualMedia | null;
  createdAt?: Date;
  updatedAt?: Date;
  isSelected: boolean;
  settings?: string | IOverlaySettings;
}

export interface IVideoBackground {
  id: string;
  order: number;
  startSecond: number;
  endSecond: number;
  videoId: string;
  visualMediaId: string;
  visualMedia: IVisualMedia;
  createdAt: Date;
  updatedAt: Date;
}
export interface IPlaylistVisualMedia {
  id: string;
  order: number;
  downloaded: boolean;
  playlistId: string;
  visualMediaId: string;
  visualMedia: IVisualMedia;
  createdAt: Date;
  updatedAt: Date;
}

export interface IVideo {
  id: string;
  name: string;
  repeatVideo: boolean;
  keepLastFrame: boolean;
  fadeBetweenBackgrounds: boolean;
  duration: number;
  compiledVideoUrl?: string;
  changedAfterCompile: boolean;
  liveStreamId: string;
  audios: IVideoAudio[];
  backgrounds: IVideoBackground[];
  overlays: IOverlay[];
  createdAt: Date;
  updatedAt: Date;
}

export interface IPlaylist {
  id: string;
  name: string;
  duration: number;
  compiledVideoUrl?: string | null;
  changedAfterCompile: boolean;
  resolutionTier?: LiveStreamResolutionEnum | null;
  liveStreamId: string;
  overlays: IOverlay[];
  playlistVisualMedias: IPlaylistVisualMedia[];
  createdAt: Date;
  updatedAt: Date;
}

export interface IMediaApply {
  action: "start" | "update";
  state: "waiting" | "failed";
  reasonCode?: string;
}

export interface ILiveStream {
  id: string;
  type: LiveStreamTypeEnum;

  status: LiveStreamStatus;
  error: boolean;
  canStop: boolean;
  desiredRunning: boolean;
  /** Pending media operation, returned by stream detail and save. */
  mediaApply?: IMediaApply | null;
  /** Bumped by every content/settings write (api media-mutation.service changed()). */
  contentRevision?: number;
  orientation: LiveStreamOrientationEnum;
  resolution: LiveStreamResolutionEnum;
  fps: number;
  videoWidth: number;
  videoHeight: number;
  videoTop: number;
  videoLeft: number;
  videoBitrate: number;
  videoFPS: number;
  audioBitrate: number;
  crfMode: boolean;
  videoFadeInDuration: number;
  videoFadeOutDuration: number;
  audioMixingEnabled: boolean;
  audioMixingDuration: number;

  promoted: boolean;
  promotedUrl?: string;

  // scheduling options
  startOption: LiveStreamStartOptionEnum;
  endOption: LiveStreamEndOptionEnum;
  startDate?: Date;
  endDate?: Date;
  // playback settings
  playbackOrder: LiveStreamPlaybackOrderEnum;
  fadeBetweenTransitions: boolean;

  repeatOnEnd: boolean;
  contentDuration: number;
  compilingStartedAt?: Date;
  compiledVideoUploading?: boolean;
  compiledVideoUrl?: string;
  compiledDurationStr?: string;
  compiledDurationSeconds?: number;

  // Jingle settings
  jingleEvery: number;
  jingleEveryType: LiveStreamJingleEveryTypeEnum;
  jinglePlaybackOrder: LiveStreamPlaybackOrderEnum;

  // New GST feature settings
  isGST: boolean;
  canVideoFade: boolean;
  canAudioCrossfade: boolean;

  // GST Overlay settings
  canShapes: boolean;
  canCustomElements: boolean;

  restarts: number;
  lastRestartAt?: Date;
  /** Start of the most recent run; with endedAt it gives the last run's duration. */
  lastStartedAt?: Date | string | null;

  termsAgreedAt?: Date | string | null;
  contentAgreedAt?: Date | string | null;

  activeItemId?: string;
  activeItemSeconds?: number;
  lastPingAt?: Date;
  activeBitrate?: string;
  activeSpeed?: string;

  activeShowId?: string;
  activeShowItemId?: string;
  activeShowItemSeconds?: number;

  viewers: number;
  likes: number;
  previewUrl?: string;

  lastAnalyticAt: Date;

  playlistId?: string | null;
  playlist?: IPlaylist | null;
  videoId?: string | null;
  video?: IVideo | null;
  ownedDestinations: IStreamingPlatform[];

  storageBytesUsed: number;
  storageBytesReserved: number;
  converting: boolean;
  activeWorkerPlan?: StreamPlan | null;
  evictionSnapshot?: EvictionSnapshot | null;
  liveStreamScheduledShows: ILiveStreamScheduledShow[];

  jinglePlaylist?: IPlaylist;
  jinglePlaylistId?: string;
  jingleVideo?: IVideo;
  jingleVideoId?: string;

  secondaryVideo?: IVideo;
  secondaryVideoId?: string;
  secondaryVideoVolume: number;

  endedAt?: Date;
  createdAt: Date;
  updatedAt: Date;

  userId?: string;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    lastSeenAt: string;
    country: string;
  };
  promotedAccepted?: boolean;
}

export interface ILiveStreamScheduledShow {
  id: string;
  name: string;
  /** Minutes after local midnight (0–1439); the show repeats daily (decision #13). */
  startMinuteOfDay: number;
  /** IANA time zone of startMinuteOfDay, e.g. "Europe/Berlin". */
  timezone: string;
  videoId?: string;
  video?: IVideo;
  playlistId?: string;
  playlist?: IPlaylist;
  switchMode: "wait" | "immediate";
}

export interface ILiveStreamAnalytics {
  id: string;
  views: number;
  likes: number;
  createdAt: string;
}

export enum AnalyticsDateRangeEnum {
  today = "today",
  last7days = "last7days",
  last14days = "last14days",
}

export enum AnalyticsDataTypeEnum {
  likes = "likes",
  views = "views",
}
